export const defaultSelectedMessage = (jobTitle: string) => {
  return `Parabéns! Você foi selecionado para a próxima etapa do processo seletivo da vaga ${
    jobTitle || ''
  }, aguarde a empresa entrar em contato.`;
};

export const defaultNotSelectedMessage = () => {
  return 'Agradecemos a sua candidatura, a vaga que você se candidatou já foi preenchida! Mas você pode concorrer a outras oportunidades de emprego no aplicativo.';
};
